import React from 'react';

export default function FlexCard({ title, subtitle, imageUrl, buttonLabel, buttonLink }) {
  return (
    <div className="bg-white rounded-2xl shadow-md overflow-hidden max-w-xs w-full text-left border border-gray-200">
      <img
        src={imageUrl}
        alt={title}
        className="w-full object-cover aspect-[16/10]"
      />
      <div className="px-4 pt-3 pb-1 space-y-2">
        <div className="text-base font-semibold text-gray-900">{title}</div>
        <div className="text-sm text-gray-600 whitespace-pre-line">{subtitle}</div>
      </div>
      <div className="px-4 pb-4 pt-2">
        <a
          href={buttonLink}
          target="_blank"
          rel="noopener noreferrer"
          className="block w-full text-center text-white text-sm font-medium bg-black hover:bg-gray-800 px-4 py-2 rounded-full transition"
        >
          {buttonLabel}
        </a>
      </div>
    </div>
  );
}
